import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import gameActions from 'redux/actions/gameActions'
import { localize } from 'helpers/translator'

const GameCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('creationTool_activity_cancelConfirm')}
		actionButtonType={0}
		actionOne={props.actions.gameCancelCancelled}
		actionTwo={props.actions.gameCancelConfirmed}
		closeAction={props.actions.gameCancelCancelled}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		gameCancelCancelled: gameActions.gameCancelCancelled,
		gameCancelConfirmed: gameActions.gameCancelConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GameCancelConfirm)

export { GameCancelConfirm }
